export default __webpack_public_path__ + "static/article-find-the-best-car-loan-5e60787ae1db73e640720787de09faf7.jpg";